import { createAction, props } from '@ngrx/store';
import { PepTypes } from '../../shared/enums';
import { FullData } from 'src/app/shared/interfaces/interfaces';

export const savePepData = createAction(
    PepTypes.PEP_SAVE_DATA,
    props<{ pepData: FullData, pepStatus: boolean }>()
);

export const sendPepData = createAction(
    PepTypes.SEND_PEP_DATA
);

export const sendPepDataSuccess = createAction(
    PepTypes.SEND_PEP_DATA_SUCCESS
);

export const sendPepDataError = createAction(
    PepTypes.SEND_PEP_DATA_ERROR
);

